/** Filter options for the badge list view */
export enum BadgeFilter {
  ALL = 'all',
  EARNED = 'earned',
  NOT_EARNED = 'not_earned',
}

/** Sort options for the badge list view */
export enum BadgeSort {
  MOST_RECENT = 'most_recent',
  OLDEST_FIRST = 'oldest_first',
  NAME_AZ = 'name_az',
  MOST_EARNED = 'most_earned',
}
